import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getInventoryTransferListAsync } from "../actions/omsPageActions";

interface InventoryTransferItem {
  [key: string]: any;
}

interface PaginationState {
  pageNumber: number;
  count: number;
}

interface InventoryTransferState {
  loading: boolean;
  transferList: InventoryTransferItem[];
  pagination: PaginationState;
}

const initialState: InventoryTransferState = {
  loading: false,
  transferList: [],
  pagination: {
    pageNumber: 1,
    count: 0,
  },
};

const inventoryTransferSlice = createSlice({
  name: "inventoryTransferSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // pending
    builder.addMatcher(
      isAnyOf(getInventoryTransferListAsync.pending),
      (state) => {
        state.loading = true;
      }
    );

    // rejected
    builder.addMatcher(
      isAnyOf(getInventoryTransferListAsync.rejected),
      (state) => {
        state.loading = false;
      }
    );

    // fulfilled
    builder.addMatcher(
      isAnyOf(getInventoryTransferListAsync.fulfilled),
      (state, action) => {
        state.loading = false;

        const res = action.payload;

        state.transferList = res?.results?.data ?? [];
        state.pagination.count = res?.count ?? 0;

        state.pagination.pageNumber = action.meta.arg.page ?? 1;
      }
    );
  },
});

export default inventoryTransferSlice.reducer;
